import { navItems } from "@/utils/nav-items";
import { Box, Drawer } from "@mui/material";
import { SocialIcons } from "../SocialIcons";
import type { DrawerMenuProps } from "./types/DrawerMenuProps";
import { DrawerMenuDropdown } from "./DrawerMenuDropdown/DrawerMenuDropdown";
import { DrawerMenuItem } from "./DrawerMenuItem/DrawerMenuItem";

export function DrawerMenu({ open, onClose }: DrawerMenuProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box
        sx={{
          width: 250,
          p: 2,
          pt: 5,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
        role="presentation"
      >
        {navItems.map((navItem) =>
          navItem.subMenu ? (
            <DrawerMenuDropdown key={navItem.id} navItem={navItem} onClose={onClose} />
          ) : (
            <DrawerMenuItem key={navItem.id} navItem={navItem} onClose={onClose} />
          )
        )}
      </Box>

      <Box sx={{ p: 2 }}>
        <SocialIcons />
      </Box>
    </Drawer>
  );
}
